import {RouterView} from "vue-router";
import guest from "./middleware/guest";
import authenticated from "./middleware/authenticated";
import brand from "./middleware/brand";

export default [
  {
    path: '/creator',
    name: 'creator.page',
    exact: true,
    component: () => import('../pages/creator/CreatorPage'),
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/auth/Login.vue'),
    meta: {middleware: guest},
  },

  {
    path: '/forgot-password',
    name: 'password.request',
    component: () => import('../pages/auth/ForgotPassword.vue'),
    meta: {middleware: [guest]}
  },
  {
    path: '/password/reset/:token',
    name: 'password.reset',
    component: () => import('../pages/auth/ResetPassword.vue'),
    meta: {middleware: [guest]}
  },
  {
    path: '/notfound',
    name: 'notfound',
    component: () => import('../pages/NotFound.vue')
  },
];
